import { ICountyResponse } from './ICounty';
import { UUID } from 'types/shared/UUID';
import { IPropertyAddressData } from '../../address/IPropertyAddressData';
import { eUSAState } from '../../../ui-toolkit/enums/states';

export interface IAddressResponse {
  id?: UUID;
  street_address?: string;
  unit?: string;
  county?: ICountyResponse;
  city: string;
  state: eUSAState;
  zip_code: string;
}

export const convertIAddressResponseToIPropertyAddressData = ({
  id,
  state,
  street_address,
  zip_code,
  ...rest
}: IAddressResponse): IPropertyAddressData => ({
  id: id || '',
  streetAddress: street_address || '',
  zipCode: zip_code,
  stateAbbreviation: state,
  createdAt: '',
  updatedAt: '',
  ...rest,
});

export const convertIPropertyAddressDataToIAddressResponse = ({
  id,
  streetAddress,
  zipCode,
  stateAbbreviation,
  ...rest
}: IPropertyAddressData): IAddressResponse => ({
  id: !!id ? id : undefined,
  street_address: !!streetAddress ? streetAddress : undefined,
  zip_code: zipCode,
  state: stateAbbreviation as eUSAState,
  ...rest,
});
